import { AppData, Platform } from "../types/app";

export const byReleaseDesc = (apps: AppData[]) =>
  [...apps].sort((a, b) => b.released_at.localeCompare(a.released_at));

// 홈 앱 카드 (D-04). pinned 중 최신 1개, 없으면 전체 최신. 최신 앱은 pinned를 뺀 최신.
export function pickHomeApps(apps: AppData[]) {
  const sorted = byReleaseDesc(apps);
  const pinned = sorted.find((a) => a.pinned) ?? sorted[0];
  const latest = sorted.find((a) => !a.pinned && a !== pinned);
  return { pinned, latest, total: apps.length };
}

export interface AppFilter {
  q: string;
  platform: Platform | "*";
  category: string; // "*" 이면 전체
}

// D-06: name과 summary 부분 일치, 대소문자 무시.
export function filterApps(apps: AppData[], { q, platform, category }: AppFilter) {
  const needle = q.trim().toLowerCase();
  return byReleaseDesc(apps).filter(
    (a) =>
      (platform === "*" || a.platforms.includes(platform)) &&
      (category === "*" || a.category === category) &&
      (!needle || a.name.toLowerCase().includes(needle) || a.summary.toLowerCase().includes(needle))
  );
}

// 쿼리 바의 WHERE 조건. 조건이 없으면 빈 목록이고 WHERE를 생략한다.
export function whereClauses({ q, platform, category }: AppFilter) {
  const conds: string[] = [];
  if (platform !== "*") conds.push(`'${platform}' IN platform`);
  if (category !== "*") conds.push(`category = '${category}'`);
  if (q.trim()) conds.push(`(name ILIKE '%${q.trim()}%' OR summary ILIKE '%${q.trim()}%')`);
  return conds;
}
